import React, { useState } from 'react';
import { Button } from 'reactstrap';
import './connectionTests.css';
import { connect } from 'react-redux';
import { getModemverbose } from '../../../../../actions/EpikBoxes';
import loadingSpinner from '../../../../../Res/logo-loading.gif';
import signalIcon from '../../../../../Res/signal.svg';
import signalIconLoading from '../../../../../Res/signalloading.svg';

function ConnectionPingControls({
  vpnAddress,
  getModemverbose,
}) {
  const [loadingCheck, setLoadingCheck] = useState(false);
  const [cellData, setCellData] = useState(null);
  const [error, setError] = useState(null);

  const token = localStorage.getItem('jwtToken') || '';

  const runCheck = async () => {
    setLoadingCheck(true);
    setError(null);
    setCellData(null);

    try {
      const res = await getModemverbose(token, vpnAddress);
      setCellData(res?.serving_cell || null);
    } catch (err) {
      console.error(err);
      setError('Failed to fetch signal data');
    } finally {
      setLoadingCheck(false);
    }
  };

  const hasData =
    cellData &&
    (cellData.rssi || cellData.rsrp || cellData.rsrq || cellData.rssnr);

  return (
    <div className="connectionWrapper">

      <div className="testCard">

        <div className="testHeader">
          <div className="testHeaderLeft">
            <h5>Cell Signal Check</h5>
            <p>
              Reads modem signal metrics, IP configuration and serving cell information.
            </p>
          </div>

          <div className="testHeaderRight">
            <Button
              color="primary"
              onClick={runCheck}
              disabled={loadingCheck}
            >
              ▶ Run Check
            </Button>
          </div>
        </div>

        {error && (
          <div className="emptyBox">
            <p style={{ color: 'red' }}>{error}</p>
          </div>
        )}

        {!hasData && !loadingCheck && !error && (
          <div className="emptyBox">

            <div className="wifiIcon">
              <img src={signalIconLoading} alt="signal" />
            </div>

            <h6>No signal data yet</h6>
            <p>Click "Run Check" to query modem signal data.</p>
          </div>
        )}

        {loadingCheck && (
          <div className="emptyBox">
            <img
              src={loadingSpinner}
              alt="loading"
              style={{ height: '100px' }}
            />
          </div>
        )}

        {hasData && (
          <>
            <div className="signalGoodBox">
              <img
                src={signalIcon}
                alt="signal"
              />
              Good Signal — {cellData?.rssi || '-'}
            </div>

            <div className="signalTable">
              <div className="rowItem">
                <span>RSSI</span>
                <span style={{ color: 'green', fontWeight: '600' }}>
                  {cellData?.rssi || '-'}
                </span>              </div>

              <div className="rowItem">
                <span>RSRP</span>
                <span>{cellData?.rsrp || '-'}</span>
              </div>

              <div className="rowItem">
                <span>RSRQ</span>
                <span>{cellData?.rsrq || '-'}</span>
              </div>

              <div className="rowItem">
                <span>RSSNR</span>
                <span>{cellData?.rssnr || '-'}</span>
              </div>

            </div>
          </>
        )}

      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  boxDetails: state.AppState.boxDetails?.box,
  user: state.AppState.user,
});

const mapDispatchToProps = (dispatch) => ({
  getModemverbose: (token, vpnAddress) =>
    dispatch(getModemverbose(token, vpnAddress)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ConnectionPingControls);